'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/priceList'));

    // On Patents page, removes query string from URL
    if (document.querySelector('.patents-page')) {
        let url = window.location.protocol + '//' + window.location.host + window.location.pathname;
        window.history.pushState({ path: url }, '', url);
    }
});
